"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var tab_controller_1 = __importDefault(require("@hikakaku/shared/stimulus/tab_controller"));
exports.default = tab_controller_1.default;
